import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AnimeCard from '@/components/base/AnimeCard';
import Breadcrumb from '@/components/base/Breadcrumb';
import { animeList, animeCategories } from '@/mocks/anime';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'latest');

  useEffect(() => {
    if (slug) {
      setActiveSlug(slug);
    }
    window.scrollTo(0, 0);
  }, [slug]);

  const currentCategory = animeCategories.find((c) => c.slug === activeSlug);
  const filteredAnime = animeList.filter((a) => a.categorySlug === activeSlug);

  return (
    <>
      <Navbar />

      <main className="pt-20 pb-10">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', to: '/' },
              { label: currentCategory?.name || '分类' },
            ]}
          />

          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-2">
              {currentCategory?.name}
            </h1>
            <p className="text-foreground-500 text-sm md:text-base">
              {currentCategory?.description}
            </p>
          </div>

          {/* Category Tabs */}
          <div className="mb-8">
            <div className="flex items-center gap-2 flex-wrap">
              {animeCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-5 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    activeSlug === cat.slug
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-900 text-foreground-400 hover:text-foreground-200 hover:bg-background-800 border border-background-800/50'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Anime Grid */}
          {filteredAnime.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
              {filteredAnime.map((anime) => (
                <AnimeCard key={anime.id} anime={anime} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-800 text-foreground-500">
                <i className="ri-emotion-sad-line text-2xl"></i>
              </div>
              <p className="text-foreground-500 text-sm">该分类暂无内容，请查看其他分类</p>
            </div>
          )}

          {/* Pagination Info */}
          <div className="mt-10 text-center">
            <p className="text-foreground-600 text-xs">
              共 <span className="text-primary-500 font-medium">{filteredAnime.length}</span> 部番剧
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}